<template>
  <div>
    <!-- if this is active route (e.g. /users) -->
    <template v-if="isCurrentRoute">
      <h2>{{ $t('views.projects.allworklogs .title.main') }}</h2>

       <b-row class="mb-3" align-h="between">
        <b-col cols="auto"></b-col>
        <b-col cols="auto">
          <!-- <b-button variant="outline-primary" @click="navigate('Projects.Worklogs.Add')"><b-icon icon="plus"/> {{ $t('views.worklogs.button.addworklog') }}</b-button> -->
        </b-col>
      </b-row>

      <entity-entry-table :entityKey="eCurrent.key" :entityBy="eParent" :tableSettings="table">
        <template #cell(type)="data">
          <b-badge variant="dark">{{ data.cell.value }}</b-badge>
        </template>
        <template #cell(accountingTaskId)="data">
          <p style="color:red;">{{ getAccountingTaskName(data.cell.value) }}</p>
        </template>
      </entity-entry-table>
    </template>

    <!-- if subroute is active route (e.g. /accountingtasks/detail) -->
    <section v-else>
      <router-view/>
    </section>
  </div>
</template>

<script>
import { CLASS_TABLE_FIELD_KEY_ALL, STOREMODULE_ENDPOINT_MAP, STOREMODULE_ENDPOINTMODULE_MAP } from '@/constants'

import { TableHelper } from '@/assets/js/helper/table'

import MixinEntityBase from '@/components/mixins/EntityBase'
import EntityEntryTable from '@/components/entity/EntryTable'
import http from '@/$plugins/http'

const ENTITY_KEY = 'worklogs'
const RELATION_KEY = 'accountingtasks'

export default {
  name: 'Projects.AllWorklogs',
  mixins: [MixinEntityBase],
  components: {
    EntityEntryTable
  },
  data () {
    return {
      entityKey: ENTITY_KEY,
      relationKey: RELATION_KEY,
      loading: false,
      accountingTaskNames: {}, // Store accounting task names by ID
      table: {
        helper: TableHelper,
        mapper: this.tableEntitiesMapper,
        options: {
          fields: {
            includes: [],
            excludes: [],
            sorting: ['clickUpCustomTaskId', 'taskName', 'comment', 'username', 'start', 'timeSpendInMinutes', 'isDeleted'],
            sortable: [CLASS_TABLE_FIELD_KEY_ALL],
            labelKey: 'views.projects.allworklogs.table.label.{field}',
            label: {},
            variant: {},
            class: {
              type: 'cell-min',
              status: 'cell-min cell-align-right'
            },
            thClass: {
              type: 'cell-nowrap'
            },
            tdClass: {}
          }
        },
        events: {
          rowClicked: this.tableRowClicked
        }
      }
    }
  },
  computed: {
    isCurrentRoute () {
      return Object.values(this.$route.matched[this.$route.matched.length - 1].components).find(c => c.name === this.$options.name) !== undefined
    },
    relationsIs () {
      return this.$store.getters[`${this.relationKey}/is`]
    },
    relationsDefinition () {
      return this.$store.getters[`${this.relationKey}/definition`]
    },
    relations () {
      return this.$store.getters[`${this.relationKey}/getUnwrapped`]
    }
  },
  methods: {
    tableEntitiesMapper (entities) {
      return entities
        .map(e => Object.assign({
          $routerLink: {
            name: `${this.$options.name}.Detail`,
            params: {
              [this.eCurrent.paramKey]: e.id
            }
          }
        }, e))
    },
    tableRowClicked (entity) {
      this.$router.push(entity.$routerLink)
    },
    async getAccountingTaskName (id) {
      if (this.accountingTaskNames[id]) {
        // If the accounting task name is already fetched, return it from the data property
        return this.accountingTaskNames[id]
      } else {
        // Fetch the accounting task name and store it in the data property
        try {
          this.loading = true
          const response = await http.get(`/${STOREMODULE_ENDPOINTMODULE_MAP.business}/api/${STOREMODULE_ENDPOINT_MAP.accountingtasks}/${id}`)
          const accountingTaskName = response.data.result.value.name
          this.accountingTaskNames[id] = accountingTaskName
          return accountingTaskName
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      }
    }
  },
  created () {
    TableHelper.rowClassHook(entity => entity.$routerLink ? 'has-routerlink' : null)
  }
}
</script>

<style lang="scss"></style>
